import { ActionIcon, Tooltip } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getHarvestProofStatusConfig,
  HarvestProofStatusBadgeVariant,
} from '../../utils/harvest-proof-status-config';

import {
  HarvestProofFormStatus,
  HarvestProofParcelStatus,
} from '@harvest-proof/data-access';

export interface HarvestProofStatusIconProps {
  status: HarvestProofFormStatus | HarvestProofParcelStatus;
  variant?: HarvestProofStatusBadgeVariant;
}

export const HarvestProofStatusIcon: FC<HarvestProofStatusIconProps> = ({
  status,
  variant = 'form',
}) => {
  const { t } = useTranslation();
  const config = getHarvestProofStatusConfig(status, variant);

  if (!config) {
    return null;
  }

  const Icon = config.icon;

  return (
    <Tooltip label={t(config.tooltipKey)} withArrow>
      <ActionIcon
        aria-label={t(config.labelKey)}
        color={config.color}
        component="div"
        radius="md"
        size="md"
        variant="filled"
      >
        <Icon stroke={3.5} style={{ width: '80%', height: '80%' }} />
      </ActionIcon>
    </Tooltip>
  );
};
